<template>
  <v-container
    v-if='loaded'
    fill-height
    fluid
    grid-list-xl>
    
    <v-layout wrap>
    
      <v-flex
        v-if="$can('read','press')"
        sm6 xs12 md6 lg3>

        <material-stats-card
          color="primary"
          icon="mdi-bullhorn"
          title="Press"
          sub-icon="mdi-view-list"
          :value="String(dashboardData.press)"
          :sub-text="`Press list`"
          to="/presses"
        />
      </v-flex>

      <v-flex
        v-if="$can('read','landingpage')"
        sm6 xs12 md6 lg3>

      <material-stats-card
          color="primary"
          icon="mdi-airplane-landing"
          title="Landing Page"
          sub-icon="mdi-view-list"
          :value="String(dashboardData.landingpage)"
          :sub-text="`Landing Page list`"
          to="/landingpages"
        />
      </v-flex>

      <v-flex
        v-if="$can('read','training')"
        sm6 xs12 md6 lg3>

        <material-stats-card
          color="primary"
          icon="mdi-cast-education"
          title="Formazione"
          sub-icon="mdi-view-list"
          :value="String(dashboardData.training)"
          :sub-text="`Formazione list`"
          to="/training"
        />
      </v-flex>

      <v-flex
        v-if="$can('read','countries_data')"
        sm6 xs12 md6 lg3>

        <material-stats-card
          color="primary"
          icon="mdi-earth-box"
          title="Countries Data"
          sub-icon="mdi-view-list"
          :value="String(dashboardData.countries_data)"
          :sub-text="`Countries list`"
          to="/countries_data"
        />
      </v-flex>



      <v-flex md12  v-if="$can('read','log')">
        <app-table :filters="{httpv: {http_verb: '!=GET'}}" hide-upsert :config="config_log" title="Logs" />
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import { getDashboardData } from '@/api/log'

import config_log from '@/views/config_log'

export default {
  data () {
    return {
      config_log,
      dashboardData: {
        protocol:'',
        site:'',
        accouhnt:'',
        meddra_version:''
      },
      loaded: false,
    }
  },
  computed: {
  },
  async mounted () {
    this.getDashboardData()
    this.config_log.setApp(this)
  },
  methods: {
    getDashboardData () {
      getDashboardData().then(data => {
        this.dashboardData = data
        this.loaded = true
      })
    },
     editShipment(shipment) {
      this.$router.push(`/shipment/${shipment.id}`)
    },
    copyLog(item) {
      const value = {
        REQUEST: item.request,
        RESPONSE: item.response
      }
      navigator.clipboard.writeText(JSON.stringify(value, null, 2))
      this.$root.$emit('openSnackbar', {
        message: 'Log REQUEST & RESPONSE copied to clipboard!',
        color: 'success'
      })
    }
  }
}
</script>

<style lang="scss">
.dataTable {
  .v-datatable__actions {
    color: black;
    .v-btn__content {
      color: black;
    }
    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
      padding: 0px 5px 0px 5px;
  }
}
</style>
